<template>
  <div class="content-430 settlement-list-box">
    <div class="title">
      <p>
        <span>{{ titleStr }}</span><span>校内课后服务综合管理平台</span>
        <span v-if="tableType == 2"> {{ settleMonth }}学校确认单</span>
      </p>
      <p>
        <span v-if="tableType == 1"> {{ settleMonth }}机构结算单</span> -
        <span v-if="orgName">{{ orgName }}</span>（订单明细）
        <!--  -->
        <Tag
          v-if="eduAreaCode == '440114' && isNinthMonth != 'true'&&isTrueTally == 0"
          :color="isTrueTally == 0 ? 'default' : 'primary'"
          style="margin-left: 16px"
        >{{ isTrueTally == 0 ? '通用账单' : '实际账单' }}</Tag>
      </p>
    </div>
    <div v-if="true" class="btn-box">
      <div class="search">
        <Form ref="searchForm" :model="formInline" :label-width="0" inline>
          <FormItem>
            <Input
              v-model="formInline.orderId"
              type="text"
              placeholder="请输入订单编号"
              clearable
            >
            </Input>
          </FormItem>
          <FormItem>
            <Input
              v-model="formInline.studentName"
              type="text"
              placeholder="学生姓名"
              clearable
            >
            </Input>
          </FormItem>
          <Button
            type="primary"
            style="margin-left: 16px"
            @click="handleSubmit"
          >查询</Button>
          <Button style="margin-left: 16px" @click="handleReset">重置</Button>
        </Form>
      </div>
      <Button
        class="btn-download"
        type="primary"
        @click="handleDownload"
      >下载</Button>
    </div>
    <div class="count" style="margin-bottom: 18px">
      结算课时（课程）：<strong style="margin-right: 12px">{{
        count.classroomTotal
      }}</strong>
      结算金额：<strong style="margin-right: 12px">{{
        abs(count.settleAmount)
      }}</strong>
      <span>
        机构应结算金额：<strong style="margin-right: 12px">{{
          abs(count.orgSettleAmountTotal)
        }}</strong>
      </span>
      <!-- <span v-if="!sheetIds">
        机构应结算金额(线上)：<strong style="margin-right: 12px">{{
          abs(count.orgSettleOnlineAmount)
        }}</strong>
      </span>
      <span v-if="!sheetIds">
        机构应结算金额(线下)：<strong style="margin-right: 12px">{{
          abs(count.orgSettleOfflineAmount)
        }}</strong>
      </span> -->
      <span>
        平台服务费：<strong style="margin-right: 12px">{{
          abs(count.serviceAmountTotal)
        }}</strong>
      </span>
      <!-- <span v-if="!sheetIds">
        平台服务费(线上)：<strong style="margin-right: 12px">{{
          abs(count.serviceOnlineAmount)
        }}</strong>
      </span>
      <span v-if="!sheetIds">
        平台服务费(线下)：<strong style="margin-right: 12px">{{
          abs(count.serviceOfflineAmount)
        }}</strong>
      </span> -->

      手续费金额：<strong style="margin-right: 12px">{{
        abs(count.wxAmt)
      }}</strong>
      平台手续费：<strong style="margin-right: 12px">{{
        abs(count.platformPoundage)
      }}</strong>

      机构手续费：<strong style="margin-right: 12px">{{
        abs(count.merchantPoundage)
      }}</strong>
    </div>
    <Table
      :loading="loading"
      border
      :columns="tableColumns"
      :no-data-text="noDataText"
      :data="tableData"
      max-height="485"
    >
      <template slot="paySts" slot-scope="{ row, index }">
        <span>{{ row.paySts | initPaySts }}</span>
      </template>

      <template slot="platformCommission" slot-scope="{ row, index }">
        <span> {{ (Number(row.platformCommission) / 100).toFixed(2) }} </span>
      </template>
      <template slot="merchantCommission" slot-scope="{ row, index }">
        <span> {{ (Number(row.merchantCommission) / 100).toFixed(2) }} </span>
      </template>

      <template slot="refundCreateTime" slot-scope="{ row, index }">
        <span>{{ row | initRefundCreateTime }}</span>
      </template>

      <template slot="refundReason" slot-scope="{ row, index }">
        <span v-if="row.refundFeeStr == '0.00'">-- {{ row | initRefundReason }}</span>
        <div v-else>
          <Poptip
            trigger="hover"
            word-wrap
            :width="
              row.refundReason && row.refundReason.length > 200 ? 600 : 300
            "
            :transfer="true"
            :content="row.refundReason"
          >
            <span class="click-btn-430">{{ getDesc(row.refundReason) }}</span>
          </Poptip>
        </div>
      </template>
      <template slot="refundSts" slot-scope="{ row, index }">
        <span>{{ row | initRefundSts }}</span>
      </template>
    </Table>
    <div class="page-main">
      <Page
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        show-sizer
        show-total
        show-elevator
        :page-size-opts="pageSizeOpts"
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="onPageSizeChange"
      ></Page>
    </div>
    <Modal
      v-model="showExportModal"
      :mask-closable="false"
      title="正在导出"
      @on-cancel="handleCancelExport"
    >
      <Progress :percent="percent" :stroke-width="5"></Progress>
      正在导出表格，请给我一些时间
      <div slot="footer">
        <Button @click="handleCancelExport">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getSearchsStorage } from '@/utils/storage';
import orderCenterApi from '@/request/orderCenter/index.js';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import { getColumn } from './assets/data/SettlementListTable';
import cateringAdmin from '@/request/cateringAdmin/index.js';
import commonApi from '@/request/common/index.js';
import { abs, add, yearMonthSplit, getMonthsBetweenDates, getYearMonthDate } from '@/utils/utils.js';

let IntervalId;
export default {
  components: {

  },
  filters: {
    initPaySts(val) {
      const map = {
        0: '待支付',
        1: '支付成功',
        2: '已关闭',
        7: '预支付'
      };
      return map[Number(val)] ? map[Number(val)] : '';
    },
    initRefundCreateTime(row) {
      return row.refundFeeStr == '0.00' ? '--' : row.refundCreateTime;
    },
    initRefundReason(row) {
      return row.refundFeeStr == '0.00' ? '--' : row.refundReason;
    },
    initRefundSts(row) {
      const map = {
        // 3: '全额退款',
        // 4: '部分退款',
        2: '全额退款',
        1: '部分退款'
      };
      return !row.refundSts ? '--' : map[Number(row.refundSts)];
    }

  },

  data() {
    return {
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      showExportModal: false,
      sheetId: this.$route.query.sheetId,
      isNinthMonth: this.$route.query.isNinthMonth,
      titleStr: this.$route.query.titleStr,
      beginTime: this.$route.query.beginTime,
      // beginMonth: this.$route.query.beginMonth,
      // settleMonth: this.$route.query.settleMonth,

      isTrueTally: this.$route.query.isTrueTally,
      tableType: this.$route.query.tableType, // 1:机构类表单
      eduAreaCode: this.$route.query.eduAreaCode,
      orgName: this.$route.query.orgName,
      bankId: this.$route.query.bankId,
      bankType: this.$route.query.bankType,
      statementId: this.$route.query.statementId,
      statementIds: this.$route.query.statementIds,
      sheetIds: this.$route.query.sheetIds,
      noShowOtherColumns: !!this.$route.query.noShowOtherColumns,
      loading: false,
      schId: this.$route.query.schId,
      orgId: this.$route.query.orgId,
      orgIds: this.$route.query.orgIds,
      tableColumns: [],
      noDataText: '账单待生成',
      tableData: [],
      portOrg: localStorage.getItem('portOrg'),
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0

      },
      formInline: {
        orderId: '',
        studentName: ''
      },
      downloadUrl: '', // 下载地址
      downloadToken: '',

      percent: 0, // 进度条,
      userIp: '',
      count: {
        classroomTotal: 0, // 结算课时
        settleAmount: 0, // 结算金额
        orgAmount: 0, // 机构应结算金额
        platformAmount: 0, // 平台服务费
        wxAmt: 0, // 手续费金额
        platformPoundage: 0.0, // 平台手续费
        merchantPoundage: 0.0, // 机构手续费
        orgSettleAmountTotal: 0.0, // 机构应结金额
        orgSettleOnlineAmount: 0.0, // 机构应结金额(线上)
        orgSettleOfflineAmount: 0.0, // 机构应结金额(线下)
        serviceAmountTotal: 0.0, // 平台服务费金额
        serviceOnlineAmount: 0.0, // 平台服务费金额(线上)
        serviceOfflineAmount: 0.0 // 平台服务费金额(线下)
      },
      sheetBeginTime: this.$route.query.sheetBeginTime,
      sheetEndTime: this.$route.query.sheetEndTime,
      isShowSignMonthlyAmount: 0,
      monthList: []
    };
  },
  computed: {
    settleMonth() {
      console.log(this.sheetEndTime, '拿到的护具-------');
      // const { beginTime, endTime } = this.detailsData;
      const beginTime = this.sheetBeginTime;
      const endTime = this.sheetEndTime;
      const { year: beginYear, month: beginMonth } = getYearMonthDate(beginTime);
      const { year: endYear, month: endMonth } = getYearMonthDate(endTime);
      if (!endYear || !endMonth) {
        return `${beginYear}年${beginMonth}月`;
      } else if (beginYear === endYear && beginMonth === endMonth) {
        return `${beginYear}年${beginMonth}月`;
      } else if (beginYear === endYear) {
        return `${beginYear}年${beginMonth}~${endMonth}月`;
      } else {
        return `${beginYear}年${beginMonth}月~${endYear}年${endMonth}月`;
      }
    },
    beginMonth() {
      const beginTime = this.sheetBeginTime;
      const endTime = this.sheetEndTime;
      const { year: beginYear, month: beginMonth } = getYearMonthDate(beginTime);
      const { year: endYear, month: endMonth } = getYearMonthDate(endTime);
      if (!endYear || !endMonth) {
        return `${beginMonth}月`;
      } else if (beginYear === endYear && beginMonth === endMonth) {
        return `${beginMonth}月`;
      } else if (beginYear === endYear) {
        return `${beginMonth}-${endMonth}月`;
      } else {
        return `${beginMonth}-${endMonth}月`;
      }
    }
  },
  created() {
    commonApi.getIpAddr().then(res => {
      this.userIp = res.message;
    });
    // getIPs((ip) => {

    //   console.log(ip)
    //   // console.log(getUserIp());
    // })
    this.dealMonth();
    this.initColumn();

    if (this.sheetIds) {
      this.getBillOrderDetailsStatisticsTotal();
    } else {
      this.getToSettleBillDetails();
    }

    this.getProductTallyOrderDetailList();
  },
  methods: {
    dealMonth() {
      if (!this.sheetEndTime) {
        this.isShowSignMonthlyAmount = 0;
        this.monthList = [this.sheetBeginTime.split('-')[1]];
      } else {
        const beginTime = yearMonthSplit(this.sheetBeginTime);
        const endTime = yearMonthSplit(this.sheetEndTime);
        this.monthList = getMonthsBetweenDates(beginTime, endTime);
        this.isShowSignMonthlyAmount = beginTime === endTime ? 0 : 1;
      }
      console.log(this.isShowSignMonthlyAmount, this.monthList, '拿到的处理数据---');
    },
    abs(num) {
      return abs(num);
    },
    getDesc(str) {
      return str && str.length > 20 ? str.substring(0, 20) + '...' : str;
    },
    initColumn() {
      const tableColumns = getColumn({
        title: this.beginMonth,
        bankType: this.bankType,
        showTotalData: true
      });
      if (this.portOrg != 0) {

      }
      this.tableColumns = tableColumns;
      if (this.monthList.length > 1) {
        const index = this.tableColumns.findIndex(item => item.key === 'refundPendingFee');
        let columnsList = [];
        this.monthList.forEach(item => {
          columnsList = columnsList.concat([
            { key: `${item}leaveRefundableAmount`,
              title: `${item}月请假可退款金额`,
              minWidth: 130,
              align: 'center'

            },
            { key: `${item}settleTotal`,
              title: `${item}月结算课时`,
              minWidth: 130,
              align: 'center'

            },
            { key: `${item}settleAmount`,
              title: `${item}月结算金额`,
              minWidth: 130,
              align: 'center'

            }]);
        });
        this.tableColumns.splice(index + 1, 0, ...columnsList);
      }
    },
    handleSubmit() {
      this.pageInfo.pageNum = 1;
      this.getProductTallyOrderDetailList();
    },
    handleReset() {
      this.formInline.orderId = '';
      this.formInline.studentName = '';
      this.handleSubmit();
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getProductTallyOrderDetailList();
    },
    onPageSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getProductTallyOrderDetailList();
    },
    // 获取统计数据
    async getToSettleBillDetails() {
      const bankType = this.bankType;
      const res = await orderCenterApi.getBillOrderDetailsStatistics({
        sheetId: this.sheetId
      });
      if (res.status == 200) {
        for (const k in res.message) {
          this.count[k] = res.message[k];
        }
        this.count.orgSettleAmountTotal = add(res.message.orgSettleOnlineAmount, res.message.orgSettleOfflineAmount);
        this.count.serviceAmountTotal = add(res.message.serviceOnlineAmount, res.message.serviceOfflineAmount);
      }
    },
    async getBillOrderDetailsStatisticsTotal() {
      const res = await orderCenterApi.getBillOrderDetailsStatisticsTotalApi({
        sheetIds: this.sheetIds
      });
      if (res.status == 200) {
        for (const k in res.message) {
          this.count[k] = res.message[k];
        }
        this.count.orgSettleAmountTotal = add(res.message.orgSettleOnlineAmount, res.message.orgSettleOfflineAmount);
        this.count.serviceAmountTotal = add(res.message.serviceOnlineAmount, res.message.serviceOfflineAmount);
      }
    },
    actionOtherSubTableColumn() {
      if (this.tableData.length > 0) {
        const single = getSearchsStorage('settlementActionShow');
        if (single && !this.noShowOtherColumns) {
          this.showOtherSubTableColumn();
        } else {
          //        this.hideOtherSubTableColumn()
        }
      }
    },
    getOtherOrgs(checkList) {
      const map = {};
      this.tableData.forEach(item => {
        item.otherSubLedgerParties.forEach(item_1 => {
          if (!map[item_1.orgId] && checkList.findIndex(item => { return item.key == ('otherOrgName' + item_1.orgId); }) == -1) {
            map[item_1.orgId] = {
              orgId: item_1.orgId,
              orgName: item_1.orgName
            };
          }
        });
      });
      const arr = [];
      for (const k in map) {
        arr.push(map[k]);
      }
      return arr;
    },
    showOtherSubTableColumn() {
      const key = this.tableColumns.findIndex(item => { return item.key && item.key.indexOf('otherOrgName') > -1; });
      if (key != -1) {
        return null;
      }
      const arr = this.getOtherOrgs(this.tableColumns);

      const data = [];
      arr && arr.forEach((item, index) => {
        data.push({
          title: item.orgName,
          key: `otherOrgName` + (item.orgId),
          width: 180,
          align: 'center'
        });
      });

      this.tableColumns.splice(26, 0, ...data);
    },

    // 明细详情列表
    async getProductTallyOrderDetailList() {
      const { orderId, studentName } = this.formInline;
      this.loading = true;
      console.log(this.$route.query.orgIds, this.orgIds, '拿到orgIds: this.$route.query.orgIds,');

      const params = {
        sheetId: this.sheetId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        orderId,
        studentName,
        statementIds: this.statementIds,
        schoolId: this.schId
        // isShowSignMonthlyAmount: this.isShowSignMonthlyAmount
      };
      if (this.isShowSignMonthlyAmount === 1) {
        params.isShowSignMonthlyAmount = this.isShowSignMonthlyAmount;
      }
      if (this.orgIds) {
        params.orgIds = this.orgIds;
      }
      const res = await orderCenterApi.getBillOrderLedgerDetails(params);
      this.loading = false;
      if (res.status == 200) {
        let { list, total } = res.message;
        const otherOrgNameMap = [];
        const feeList = [];
        list = list.map(item => {
          if (item.otherSubLedgerParties && item.otherSubLedgerParties.length > 0) {
            item.otherSubLedgerParties.forEach((item_1, index_1) => {
              item['otherOrgName' + (item_1.orgId)] = item_1.divAmt;
              if (!otherOrgNameMap.includes('otherOrgName' + (item_1.orgId))) {
                otherOrgNameMap.push('otherOrgName' + (item_1.orgId));
              }
            });
          }
          item.monthOrgSettleAmountTotal = add(item.monthOrgSettleOnlineAmount, item.monthOrgSettleOfflineAmount);
          item.monthServiceAmountTotal = add(item.monthServiceOnlineAmount, item.monthServiceOfflineAmount);
          const data = {};
          this.monthList.forEach(x => {
            data[`${x}leaveRefundableAmount`] = '0';
            data[`${x}settleAmount`] = '0';
            data[`${x}settleTotal`] = '-';
          });
          if (item.monthlySettlementAmountMap) {
            Object.keys(item.monthlySettlementAmountMap).forEach(x => {
              Object.keys(item.monthlySettlementAmountMap[x]).forEach(j => {
                if (['leaveRefundableAmount', 'settleAmount'].includes(j)) {
                  data[`${x}${j}`] = item.monthlySettlementAmountMap[x][j];
                  feeList.includes(`${x}${j}`) ? '' : feeList.push(`${x}${j}`);
                } else if (['settleTotal'].includes(j)) {
                  data[`${x}${j}`] = item.monthlySettlementAmountMap[x][j];
                }
              });
            });
          }
          console.log(data, '哪代的书u');
          return { ...item, ...data };
        });

        this.handleEventTableData(list, ['originalFee', 'offerFee', 'refundFee', 'settleAmount', 'refundPendingFee', 'monthLeaveRefundableAmount', 'monthSettleAmount', 'monthOrgSettleAmountTotal', 'monthOrgSettleOnlineAmount', 'monthOrgSettleOfflineAmount', 'monthServiceAmountTotal', 'monthServiceOnlineAmount', 'monthServiceOfflineAmount', 'wxAmt', '', ...feeList, ...otherOrgNameMap]);
        this.tableData = list;
        this.pageInfo.total = Number(total);
        this.actionOtherSubTableColumn();
      }
    },
    //  处理金额参数
    handleEventTableData(val, targets) {
      val.forEach(item => {
        targets.forEach(target => {
          try {
            //     item[target] === null ? item[target] = 0 : ''
            item[target] = !item[target] ? '0.00' : this.abs(parseInt(item[target]));
          } catch (err) {

          }
        });
      });
    },
    // 获取任务id
    async getTaskId(parameter) {
      return new Promise(async(resolve, reject) => {
        let res;
        // switch (Number(this.portOrg)) {
        //   case 0:

        res = await orderCenterApi.getUserOrderTaskIdByAdmin(parameter);
        if (res.data.status == 200) {
          resolve(res.data.message);
        }
        //     break;
        // }
      });
    },
    // 下载处理
    async handleDownload(data) {
      if (!this.tableData.length) {
        return this.$Message.warning('暂无数据导出');
      }
      const single = getSearchsStorage('settlementActionShow');

      const { orderId, studentName } = this.formInline;
      const parameter = { orderId, studentName, sheetId: this.sheetId, isShowOtherSubpayers: single && !this.noShowOtherColumns ? 1 : 0 };
      this.statementIds ? parameter.statementIds = this.statementIds : '';
      this.schId ? parameter.schoolId = this.schId : '';
      this.orgIds ? parameter.orgIds = this.orgIds : '';
      if (this.isShowSignMonthlyAmount === 1) {
        parameter.isShowSignMonthlyAmount = this.isShowSignMonthlyAmount;
      }
      this.$Spin.show();
      const res = await orderCenterApi.exportBillOrderLedgerDetails(parameter);
      this.$Spin.hide();
      if (res.data.type === 'application/vnd.ms-excel') {
        this.$Message.success('导出成功');
        downLoadByBlob(res);
      } else {
        this.$Message.error('导出失败');
      }
    },
    // 下载token
    async getDownloadtoken(fileId) {
      return new Promise(async(resolve, reject) => {
        const params = {
          fileId: [fileId],
          type: 2
        };
        const res = await cateringAdmin.getDownloadtoken(params);
        if (res.status === 200) {
          this.downloadUrl = res.message.downUrl;
          this.downloadToken = res.message.token;
        }
        resolve();
      });
    },
    percentShowFun() {
      this.percent += 20;
      if (this.percent >= 80) {
        clearInterval(IntervalId);
      }
    },
    percentShow() {
      this.percent = 0;
      IntervalId = setInterval(this.percentShowFun, 500);
    },
    // 导出取消
    handleCancelExport() {
      console.log('取消');
      this.showExportModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.settlement-list-box {
  /deep/ .ivu-tag-size-default {
    background: #2db7f5;
    .ivu-tag-text {
      color: #fff;
    }
  }
  .ivu-tag-primary {
    background: #488ffa;
  }
  .btn-box {
    display: flex;
    justify-content: space-between;
    /* position: absolute;
    right: 32px;
    top: 32px; */
  }
  .title {
    position: relative;
    text-align: center;

    margin-bottom: 32px;
    p {
      font-size: 22px;
      font-weight: bold;
      line-height: 34px;
      span {
        font-size: 22px;
        font-weight: bold;
      }
    }
  }
  .page-main {
    padding: 15px 0;
    text-align: right;
  }
}

</style>
